import { useInputHelper, InputHelper } from 'ui-builder';

export type { InputHelper };

export default useInputHelper;
